import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Tooltip,
    Legend,
} from "recharts";

const PieChartGraph = ({ data, activeTab }) => {
    const chartData = {
        Semana: [
            { name: "Ventas", value: 400 },
            { name: "Marketing", value: 300 },
            { name: "Desarrollo", value: 200 },
            { name: "Soporte", value: 100 },
        ],
        Mes: [
            { name: "Ventas", value: 1600 },
            { name: "Marketing", value: 1200 },
            { name: "Desarrollo", value: 800 },
            { name: "Soporte", value: 400 },
        ],
        Año: [
            { name: "Ventas", value: 19200 },
            { name: "Marketing", value: 14400 },
            { name: "Desarrollo", value: 9600 },
            { name: "Soporte", value: 4800 },
        ],
    };

    const displayData = data?.[activeTab] || chartData[activeTab] || [];
    const COLORS = ["#0c5b67", "#30808c", "#7ab2ba", "#a8d0d6"];

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "block",
                position: "relative",
            }}
        >
            <ResponsiveContainer
                width="100%"
                height="100%"
                minWidth={0}
                minHeight={0}
            >
                <PieChart
                    margin={{
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <Pie
                        data={displayData}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        paddingAngle={5}
                        dataKey="value"
                    >
                        {displayData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                            />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "8px",
                        }}
                    />
                    <Legend
                        wrapperStyle={{
                            fontSize: "14px",
                            color: "#666",
                            paddingTop: "10px",
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PieChartGraph;
